<div class="spacer"></div>
<div>
  <div class="form">
    <p >Regel aanmaken</p>

    <!-- Category-->
    <label for="catList">Inkomsten of uitgaven?</label>
    <select [(ngModel)]="category" id="catList">
      <option *ngFor="let cat of categories" [value]="cat.key">{{cat.label}}</option>
    </select>

    <!-- Subcategory-->
    <label for="subList">Post</label>
    <select [(ngModel)]="subCategoryId" id="subList">
      <ng-container *ngIf="category">
        <option *ngFor="let subcat of getSubcategories()" [value]="subcat.id">{{subcat.name}}</option>
      </ng-container>
    </select>

    <!-- Description -->
    <label for="desc">Omschrijving</label>
    <input  id="desc" [(ngModel)]="description">

    <!-- IBAN-->
    <label for="iban">IBAN</label>
    <input id="iban" [disabled]="ibanRequiredEmpty" [(ngModel)]="iban" (change)="ibanChange()">

    <!-- IBAN required-->
    <label for="ibanReq" (change)="ibanRequiredEmptyChange()"><input id="ibanReq" type="checkbox" [(ngModel)]="ibanRequiredEmpty"> Moet IBAN leeg zijn?</label>

    <!-- buttons -->
    <button (click)="save()" class="btn" type="submit">opslaan</button>
    <button routerLink="/regels" class="btn">annuleer</button>

  </div>
</div>
